import { __read } from "tslib";
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
import { getRegexp } from '@slardar/sdk-template';
import { applyPerformance, getDefaultBrowser, getDefaultPerformance, UNKNOWN_PATH } from '../../utils';
import { buildPayload, getDataFromEvent } from './util';
var RESOURCE_ERROR_EV_TYPE = 'resource_error';
export var ResourceErrorMonitor = function (window, performance, locationHref) {
    if (window === void 0) { window = getDefaultBrowser(); }
    if (performance === void 0) { performance = getDefaultPerformance(); }
    if (locationHref === void 0) { locationHref = location === null || location === void 0 ? void 0 : location.href; }
    if (!window) {
        return;
    }
    return function (props, cb) {
        var ignoreUrls = props.ignoreUrls, includeUrls = props.includeUrls, dedupe = props.dedupe;
        var includeRegExp = getRegexp(includeUrls);
        var ignoreRegExp = getRegexp(ignoreUrls);
        var _a = __read(applyPerformance(performance), 5), getEntriesByName = _a[4];
        var lastErrPath = undefined;
        var report = function (data) {
            if (locationHref && data.url === locationHref)
                return;
            if ((includeRegExp && !includeRegExp.test(data.url)) || (ignoreRegExp && ignoreRegExp.test(data.url)))
                return;
            // url为空时 && dom path为空 对排查错误没有意义
            if (!data.url && (!data.xpath || data.xpath === UNKNOWN_PATH))
                return;
            if (dedupe && data.url === lastErrPath)
                return;
            lastErrPath = data.url;
            var payload = buildPayload(data, getEntriesByName);
            if (payload) {
                cb &&
                    cb({
                        ev_type: RESOURCE_ERROR_EV_TYPE,
                        payload: payload,
                    });
            }
        };
        var onError = function (event) {
            var e = event || window.event;
            if (!e) {
                return;
            }
            var data = getDataFromEvent(e);
            if (data) {
                report(data);
            }
        };
        window.addEventListener('error', onError, true);
        var teardown = function () {
            window.removeEventListener('error', onError, true);
        };
        return [report, teardown];
    };
};
//# sourceMappingURL=index.js.map